import "../../../styles/components/management/Chat/MessageBubble.css";

export default function MessageBubble({ message, isSeen, deliveryStatus, className = "" }) {
  const isHost = message.SOURCE === "host";

  const decodedMessage =
    message.MESSAGE_TEXT &&
    decodeURIComponent(message.MESSAGE_TEXT.replace(/\+/g, " "));

  return (
    <div className={`message-bubble ${isHost ? "host" : "guest"} ${message.SOURCE} ${className}`}>
      {decodedMessage && <p>{decodedMessage}</p>}

      {message.ATTACHMENT && (
        <div className="attachment">
          <a href={message.ATTACHMENT} target="_blank" rel="noopener noreferrer">
            {message.ATTACHMENT_NAME}
          </a>
        </div>
      )}

      <span className="timestamp">
        {new Date(message.CREATED_AT).toLocaleString([], {
          year: "numeric",
          month: "short",
          day: "numeric",
          hour: "2-digit",
          minute: "2-digit",
        })}
        {isSeen && !isHost && <span className="seen-indicator"> ✓ Seen</span>}
        {isHost && deliveryStatus === "delivered" && (
          <span className="delivery-indicator"> ✓ Delivered</span>
        )}
        {isHost && deliveryStatus === "seen" && (
          <span className="seen-indicator"> ✓ Seen</span>
        )}
      </span>
    </div>
  );
}
